import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a62646f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "has-text-left is-description mb-2"
}

type Props = {
  description?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Description',
  props: {
    description: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.description)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.description), 1 /* TEXT */))
    : _createCommentVNode("v-if", true)
}
}

})